export default {
      id: "segment__full_full_full-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#segment__full_full_full",
      toString: function () {
        return this.url;
      }
    }